import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const { signIn, confirmMFA } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [requiresMFA, setRequiresMFA] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (requiresMFA) {
        // Confirm MFA code
        await confirmMFA(mfaCode);
        setRequiresMFA(false);
        setMfaCode('');
      } else {
        // Initial sign in
        const result = await signIn(username, password);
        if (result.requiresMFA) {
          setRequiresMFA(true);
        }
      }
    } catch (err: any) {
      setError(err.message || 'Failed to sign in');
      // Reset MFA state on error
      if (requiresMFA) {
        setRequiresMFA(false);
        setMfaCode('');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>StageSpotter Admin</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Email</label>
            <input
              id="username"
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </div>
          {!requiresMFA ? (
            <>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>
            </>
          ) : (
            <div className="form-group">
              <label htmlFor="mfaCode">MFA Code</label>
              <input
                id="mfaCode"
                type="text"
                value={mfaCode}
                onChange={(e) => setMfaCode(e.target.value)}
                placeholder="Enter code from email"
                required
                autoComplete="one-time-code"
                autoFocus
              />
              <small>Enter the 6-digit code sent to your email address</small>
            </div>
          )}
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading 
              ? (requiresMFA ? 'Verifying...' : 'Signing in...') 
              : (requiresMFA ? 'Verify Code' : 'Sign In')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

